
const ProductsPagination = ({pagination}) => {
    return (
        <>
            <p className="w-full text-sm text-olaf-green-700">
                <span>Toon&nbsp;</span>
                <span className="font-medium">
                    {(pagination?.page * (pagination?.pageSize)) + 1}
                    &nbsp;
                </span>
                <span>
                    tot&nbsp;
                </span>
                <span className="font-medium">
                    {pagination?.page * (pagination?.pageSize) + pagination.pageSize}&nbsp;
                </span>
                <span>
                    van&nbsp;
                </span>
                <span className="font-medium">
                    {pagination?.totalCount}&nbsp;
                </span>
                resultaten.
            </p>
            <p className="w-full text-sm text-olaf-green-700 !mt-2">
                Pagina: {(parseInt(pagination.page) + 1)} / {(parseInt(pagination.totalPages) + 1)}
            </p>
        </>
    );
};

export default ProductsPagination;